import Vue from "vue";
import App from "./App.vue";
import axios from "axios";
import store from "./store";
import router from "./router";
import ElementUI from "element-ui";
import "element-ui/lib/theme-chalk/index.css";
import "./styles/main.scss";
import "../public/global.css";
import "./styles/global.css";
import Vant from "vant";
import "vant/lib/index.css";
// css3动画库
import "animate.css";
import VueYoutube from "vue-youtube";
Vue.use(Vant);
Vue.config.productionTip = false;
Vue.use(ElementUI);
// Vue.use(axios);
Vue.use(VueYoutube);

new Vue({
  router,
  store,

  render: (h) => h(App),
}).$mount("#app");
